module.exports = __webpack_public_path__ + "img/9_75.0ea788b6.png";